import { render } from "./Categury.vue?vue&type=template&id=72538e33"
import script from "./Categury.vue?vue&type=script&lang=js"
export * from "./Categury.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__